import { FileRecord } from '../../types/files';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { maybeParseZonedDateTime } from '~/shared/utils/dateTime';

export const filesQueryAtom = () =>
  createQueryAtomFactory(
    'files.list',
    (params: { folderId: string | null; searchTerm: string }) => ({
      files: {
        __args: {
          filter: {
            // When searching, don't filter by parentIds - search entire database
            parentIds:
              params.searchTerm && params.searchTerm.trim()
                ? undefined
                : params.folderId
                  ? [params.folderId]
                  : undefined,
            fileType: undefined, // Both Regular and Directory
            status: 'Active',
            searchTerm: params.searchTerm || undefined,
          },
          cursor: {
            limit: 1000,
            offset: 0,
          },
        },
        edges: {
          node: {
            id: true,
            fileName: true,
            fileSize: true,
            mimeType: true,
            fileType: true,
            parentId: true,
            public: true,
            template: true,
            metadata: true,
            status: true,
            path: true,
            timestamps: {
              createdAt: true,
              updatedAt: true,
            },
            creator: {
              id: true,
              firstName: true,
              lastName: true,
            },
          },
        },
        total: true,
      },
    }),
    {
      select: (data): FileRecord[] => {
        if (!data?.files?.edges) return [];

        return data.files.edges.map(
          (edge): FileRecord => ({
            id: edge.node.id,
            name: edge.node.fileName,
            type: edge.node.fileType,
            mimeType:
              edge.node.fileType === 'Directory'
                ? 'application/x-folder'
                : edge.node.mimeType,
            size: edge.node.fileSize,
            parentId: edge.node.parentId,
            path: edge.node.path
              ? edge.node.path.split('/').filter(Boolean)
              : [],
            createdAt: maybeParseZonedDateTime(edge.node.timestamps.createdAt),
            updatedAt: maybeParseZonedDateTime(edge.node.timestamps.updatedAt),
            createdBy: edge.node.creator
              ? `${edge.node.creator.firstName} ${edge.node.creator.lastName}`
              : undefined,
            metadata: edge.node.metadata || undefined,
            public: Boolean(edge.node.public),
            template: Boolean(edge.node.template),
            children: [],
          }),
        );
      },
    },
  );
